module.exports = () => {
  return {
    jobs: [],
    jobsFiltered: [],
    selectedDepartment: null,
    selectedLocation: null,
    selectedJobType: null,
    departmentsFiltered: null,
    locationsFiltered: null,
    jobTypesFiltered: null,
  }
}